import { render } from "./Hud.vue?vue&type=template&id=1b6be6a0"
import script from "./Hud.vue?vue&type=script&lang=js"
export * from "./Hud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__